module.exports = __webpack_public_path__ + "img/content5_162_15.cad7d153.png";